<div [formGroup]="dateForm">
  <p-fluid>
    <div class="p-form-widget">
      <div class="field pt-2 pb-4">
        <label class="pr-2">Date Request Received:</label>
        <div class="p-field-value">
          <p-date-picker
            appendTo="body"
            formControlName="dateTimeFaxReceived"
            hourFormat="12"
            [defaultDate]="maxDate"
            [maxDate]="maxDate"
            [readonlyInput]="true"
            [showIcon]="true"
            [showSeconds]="true"
            [showTime]="true"
            [showOnFocus]="false"
          ></p-date-picker>
        </div>
      </div>
    </div>
  </p-fluid>
<div class="flex justify-end">
  <button
    label="OK"
    pButton
    [disabled]="dateForm.invalid"
    (click)="onClose()"
  ></button>
</div>
</div>


